import { Box, Paragraph } from '@zillow/constellation-10';

type SavedReplyContentProps = {
  title: string;
  message: string;
};

export default function SavedReplyContent({ title, message }: SavedReplyContentProps) {
  return (
    <Box css={{ overflowX: 'hidden' }}>
      <Paragraph
        data-testid="saved-reply-title"
        textStyle="body-bold"
        css={{ paddingRight: 'tighter', wordBreak: 'break-word' }}
      >
        {title}
      </Paragraph>
      <Paragraph
        data-testid="saved-reply-message"
        css={{
          truncate: true,
        }}
      >
        {message}
      </Paragraph>
    </Box>
  );
}
